import { createAction } from '@reduxjs/toolkit'

import { WhoAmI } from 'types/GlobalAuthentication'

// tryValidateUser
export const validateUser = createAction('validate_user')
export const setSignedIn = createAction<WhoAmI>('set_signed_in')

// signOut
export const signOut = createAction('sign_out')
